import { CSSProperties, FC, useEffect, useRef, useState, } from 'react';
// 组件
import { ProNotification, ProSpin } from '../../antd';
import Left from './subpage/left';
import Content from './subpage/content';
import Right from './subpage/right';
import BaseStrategyPage from '../subpage/baseStrategyPage';
// 方法
import classnames from 'classnames';
import StrategyPageCountext from '../context/strategyCountext';
import useStrategyPagehook from '../hook/useStrategyhook';
import { setStrategyPageVisible } from '../util';
import { formatFormData, getOptionalValues } from './util';
import { responseSuccess } from '../../utils/messageUtils';
import { flterEmptyAndSpace } from '../../utils/utils';
// 常量
import { FormInstance } from 'antd/lib/form';
import { StrategyFormType, StrategyInitValues, StrategyPageProps } from '../interface';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';

const spinStyle: CSSProperties = { display: 'flex', };
/** 策略 */
const Strategy: FC<StrategyPageProps> = props => {
  const {
    actionRef, disabled, confirmLoading, isFullPage, wrapperClassName, optionalFiledName,
    onSubmit, fetchApi, beforeSubmit, onSuccess, onFail,
    ...resProps
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(
    confirmLoading || false,
  );
  const strategyRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLElement>();
  const detailParentRef = useRef<HTMLElement>(); //yb-layout-page-detail
  const ruleFormRef = useRef<FormInstance<any> | undefined>(); // 规则信息表单
  const contentFormRef = useRef<FormInstance<any> | undefined>(); // 内容信息表单
  const actionFormRef = useRef<FormInstance<any> | undefined>(); // 设定动作表单
  const optionalFormRef = useRef<FormInstance<any>>(); // 可选条件表单
  const { visible, pageType, ruleFormItems, actionFormItems, optionalFormItems, contentFormItems, dispatch } = useStrategyPagehook(optionalFormRef, props.ruleFormItems, props.optionalFormItems, props.actionFormItems);
  useEffect(() => {
    setStrategyPageVisible(tableRef, strategyRef, detailParentRef, visible);
  }, [visible]);
  /** 设置表单的值 */
  const handleSetFieldsValue = (initValues?: StrategyInitValues) => {
    const optionalValues = getOptionalValues(props.optionalFormItems, flterEmptyAndSpace(initValues?.content));
    // 处理下拉选默认项目
    dispatch('initContentFormItems', {optionalValues, initValues})
    setTimeout(() => {
      ruleFormRef.current?.resetFields();
      ruleFormRef.current?.setFieldsValue(initValues?.rule);
      optionalFormRef.current?.resetFields();
      optionalFormRef.current?.setFieldsValue(optionalValues);
      contentFormRef.current?.resetFields();
      contentFormRef.current?.setFieldsValue(initValues?.content);
      actionFormRef.current?.resetFields();
      actionFormRef.current?.setFieldsValue(initValues?.action);
    }, 50);
  };
  /** 批量赋值 */
  const handleSetValues = (values: StrategyInitValues) => {
    if (values.rule) ruleFormRef.current?.setFieldsValue(values.rule);
    if (values.content) contentFormRef.current?.setFieldsValue(values.content);
    if (values.action) actionFormRef.current?.setFieldsValue(values.action);
  };
  /** 单个字段赋值 */
  const handleSetValue = (formType: StrategyFormType, filed: any, value: any) => {
    if (formType === 'rule') ruleFormRef.current?.setFieldValue(filed, value);
    if (formType === 'content') contentFormRef.current?.setFieldValue(filed, value);
    if (formType === 'action') actionFormRef.current?.setFieldValue(filed, value);
  };
  /** 点击确认按钮 */
  const handleOk = async () => {
    const { values, errorInfo } = await handleValidateFields();
    if (errorInfo.length) {
      const messageNode = (
        <>
          {errorInfo.map((v: any) => (
            <div key={v.name[0]}>{v.errors[0]}</div>
          ))}
        </>
      );
      ProNotification.warning({
        message: messageNode,
        className: 'detail-page-require',
      });
      return;
    }
    await handleFinish(values);
  };
  /** 提交 */
  const handleFinish = async (values: any) => {
    // 如果定义了onSubmit方法，则新增步骤由外部实现
    if (onSubmit) {
      onSubmit(values);
      return;
    }
    if (fetchApi) {
      let params = values;
      if (beforeSubmit) {
        const newParams = await beforeSubmit(values);
        if (!newParams) return;
        params = newParams;
      }
      setSubmitLoading(true);
      const res = await fetchApi(params);
      setSubmitLoading(false);
      if (res.code === SUCCESS_STATUS_CODE) {
        responseSuccess('操作成功');
        onSuccess && onSuccess(res);
        return;
      }
      // responseError(res);
      onFail && onFail(res);
      return;
    }
    console.error('fetchApi 或 onSubmit 必须定义一个');
  };
  /** 验证和处理表单数据 */
  const handleValidateFields = async () => {
    const result: { values?: any, errorInfo: string[] } = { errorInfo: []};
    try {
      const fuleFormData = await ruleFormRef.current?.validateFields();
      result.values = { ...result.values, ...(formatFormData(fuleFormData, ruleFormItems)) };
    } catch (errorInfo: any) {
      result.errorInfo = [ ...result.errorInfo, ...errorInfo.errorFields ];
    }
    try {
      const contentFormData = await contentFormRef.current?.validateFields();
      result.values = { ...result.values, ...(formatFormData(contentFormData, contentFormItems)) };
    } catch (errorInfo: any) {
      result.errorInfo = [ ...result.errorInfo, ...errorInfo.errorFields ];
    }
    try {
      const actionFormData = await actionFormRef.current?.validateFields();
      result.values = { ...result.values, ...(formatFormData(actionFormData, actionFormItems)) };
    } catch (errorInfo: any) {
      result.errorInfo = [ ...result.errorInfo, ...errorInfo.errorFields ];
    }
    if (optionalFiledName) {
      result.values[optionalFiledName] = optionalFormRef.current?.getFieldsValue();
    }
    return result;
  };
  /** 最外层容器类名 */
  const classes = classnames('yb-StrategyPage', wrapperClassName);
  /** 对外方法 */
  if (actionRef) {
    actionRef.current = {
      hide: () => {
        dispatch('change', { visible: false });
      },
      show: () => {
        dispatch('change', { visible: true });
        return actionRef.current;
      },
      loading: () => {
        setLoading(true);
        return actionRef.current;
      },
      unLoading: () => {
        setLoading(false);
        return actionRef.current;
      },
      add: (initValues?: StrategyInitValues) => {
        dispatch('change', { visible: true, pageType: 'add', });
        handleSetFieldsValue(initValues);
        return actionRef.current;
      },
      edit: (initValues: StrategyInitValues) => {
        dispatch('change', { visible: true, pageType: 'edit', });
        handleSetFieldsValue(initValues);
        return actionRef.current;
      },
      detail: (initValues: StrategyInitValues) => {
        dispatch('change', { visible: true, pageType: 'detail', });
        handleSetFieldsValue(initValues);
        return actionRef.current;
      },
      submit: handleOk,
      emptySelected: () => {
        optionalFormRef?.current?.resetFields();
        optionalFormRef?.current?.setFieldsValue(getOptionalValues(optionalFormItems, {}));
        dispatch('empty', {});
      },
      setValues: handleSetValues,
      setValue: handleSetValue,
    };
  }
  
  return (
    <>
      {
        visible ? (
          <div ref={strategyRef} className={classes}>
            <StrategyPageCountext.Provider
              value={{
                visible,
                pageType,
                optionalFormRef,
                ruleFormItems,
                actionFormItems,
                optionalFormItems,
                contentFormItems,
                dispatch,
              }}
            >
              <ProSpin
                spinning={loading}
                style={spinStyle}
              >
                <BaseStrategyPage
                  {...resProps}
                  onOk={handleOk}
                  confirmLoading={submitLoading}
                  isFullPage={isFullPage}
                >
                  <Left ruleFormRef={ruleFormRef} disabled={disabled || pageType === 'detail'} />
                  <Content contentFormRef={contentFormRef} disabled={disabled || pageType === 'detail'} />
                  <Right actionFormRef={actionFormRef} disabled={disabled || pageType === 'detail'} />
                </BaseStrategyPage>
              </ProSpin>
            </StrategyPageCountext.Provider>
          </div>
        ) : null
      }
    </>
  );
};

Strategy.defaultProps = {
  disabled: false,
  optionalFiledName: 'optionalValues',
};

export default Strategy;

